
var React =              require("react");
var CardActionItem = require("./generic/CardActionItem.jsx");

class AddPackageButton extends React.Component {

    constructor() {
        super();   
    }

    render() {
        return <CardActionItem
                    {...this.props}
                    text="Add"
                    addedClass="blue"
                    hideTooltip={true}
                    action={this.props.action}/>
    }

}

module.exports = AddPackageButton;